import { SlicePipe, UpperCasePipe, DatePipe } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MicaChat_ChatsEntity } from '@modules/mica-chat/entities/chats.mica-chat';
import { micaChat_getColorRandom } from '@modules/mica-chat/utils/selector-random-color.mica-chat';

@Component({
  selector: 'app-mica-chat-caja-chat',
  imports: [UpperCasePipe, SlicePipe, DatePipe],
  templateUrl: './mica-chat-caja-chat.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-caja-chat.css',
})
export class MicaChatCajaChat {
  cajaChat = input.required<MicaChat_ChatsEntity>();
  getColor() {
    return micaChat_getColorRandom(this.cajaChat().nombre_contacto);
  }
}
